import { render, staticRenderFns } from "./EmEmAdmUserGroupList.vue?vue&type=template&id=71a6f352&"
import script from "./EmEmAdmUserGroupList.vue?vue&type=script&lang=js&"
export * from "./EmEmAdmUserGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports